module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07485_logo_200x200.a5d5dd5a.png";